<template>
    <div>
        <div v-show="!mostrarSubItens">
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <app-tabela
                idTabela="tblItensContrato"
                :itens="contrato.itensContrato"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false"
            >
                <template slot="botoes">
                    <div class="d-flex flex-row-reverse mb-3">
                        <btn-atualizar-valores-em-lote-item-contrato
                            :itensSelecionados="itensSelecionados"
                            :apostilamento="apostilamento()"
                            :contrato="contrato"
                            v-if="mostrarBtnAtualizarValoresEmLoteItemContrato"
                            @obterItensAtualizados="
                                $emit('obterContratoAtualizado')
                            "
                            @limparItensSelecionados="itensSelecionados = []"
                        ></btn-atualizar-valores-em-lote-item-contrato>
                        <btn-inserir-item-contrato
                            :contrato="contrato"
                            :apostilamento="apostilamento()"
                            @obterItensAtualizados="
                                $emit('obterContratoAtualizado')
                            "
                            v-if="mostrarBtnInserirItemContrato"
                        ></btn-inserir-item-contrato>
                        <btn-emitir-relatorio
                            :contrato="contrato"
                        ></btn-emitir-relatorio>
                        <remanejar-valor
                            v-if="mostrarBtnRemanejarValor"
                            :contrato="contrato"
                            :apostilamento="apostilamento()"
                            @obterItensAtualizados="$emit('obterContratoAtualizado')"
                        ></remanejar-valor>
                    </div>
                </template>
                <template slot="exportarConsumo" slot-scope="data">
                    <btn-emitir-relatorio-requisicoes :itemContratoId="data.itemContratoId">
                    </btn-emitir-relatorio-requisicoes>
                </template>
                <template slot="acoes" slot-scope="data">
                    <span class="text-primary float-left mr-1">
                        <i
                            class="fa fa-info-circle fa-lg icon-button"
                            title="Detalhar Sub-Itens"
                            @click.stop="detalharSubItens(data.itemContratoId)"
                        ></i>
                    </span>
                    <btn-emitir-relatorio-requisicoes :itemContratoId="data.itemContratoId">
                    </btn-emitir-relatorio-requisicoes>
                    <btn-atualizar-item-contrato
                        :item="data"
                        :contrato="contrato"
                        v-if="mostrarBtnAtualizarItemContrato(data)"
                        @obterItensAtualizados="
                            $emit('obterContratoAtualizado')
                        "
                        :apostilamento="apostilamento()"
                    ></btn-atualizar-item-contrato>
                    <btn-ativar-desativar-item-contrato
                        :item="data"
                        :apostilamento="apostilamento()"
                        :contrato="contrato"
                        v-if="mostrarBtnAtivarDesativarItemContrato"
                        @obterItensAtualizados="
                            $emit('obterContratoAtualizado')
                        "
                        @atualizarMensagemErro="erros = $event"
                    ></btn-ativar-desativar-item-contrato>
                </template>
                <template slot="valorUnitario" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.valorUnitario | currency }}
                    </p>
                </template>
                <template slot="saldoValor" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.saldoValor | currency }}
                    </p>
                </template>
                <template slot="saldoValorReal" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.saldoValorReal | currency }}
                    </p>
                </template>
                <template slot="status" slot-scope="data">
                    <app-status
                        :status="data.status == 1 ? 'ATIVO' : 'INATIVO'"
                    ></app-status>
                </template>
                <template slot="HEAD_itemSelecao">
                    <i
                        class="
                            fa fa-check-square fa-lg
                            text-muted
                            icon-button
                            p-0
                            m-0
                        "
                        title="Marcar/Desmarcar todos"
                        @click.stop="marcarDesmarcarTodas()"
                    ></i>
                </template>
                <template slot="itemSelecao" slot-scope="data">
                    <b-form-checkbox
                        :value="data.itemContratoId"
                        v-model="itensSelecionados"
                        v-if="data.status === 1"
                    ></b-form-checkbox>
                </template>
            </app-tabela>
        </div>
        <div v-if="mostrarSubItens">
            <app-sub-itens-contrato
                :itemContrato="itemContrato"
                :contrato="contrato"
                @fecharSubItens="itemContrato = null"
                @obterApostilamentoAtualizado="$emit('obterContratoAtualizado')"
            ></app-sub-itens-contrato>
        </div>
    </div>
</template>

<script>
import SubItensContrato from './SubItensContrato'
import BtnAtualizarItemContrato from './BtnAtualizarItemContrato'
import BtnInserirItemContrato from './BtnInserirItemContrato'
import BtnAtivarDesativarItemContrato from './BtnAtivarDesativarItemContrato'
import BtnAtualizarValoresEmLoteItemContrato from './BtnAtualizarValoresEmLoteItemContrato'
import { situacaoContrato } from '../SituacaoContrato'
import BtnEmitirRelatorio from './BtnEmitirRelatorio'
import RemanejarValor from './RemanejarValor.vue'
import BtnEmitirRelatorioRequisicoes from './BtnEmitirRelatorioRequisicoes.vue'

export default {
    components: {
        AppSubItensContrato: SubItensContrato,
        BtnAtualizarItemContrato,
        BtnInserirItemContrato,
        BtnAtivarDesativarItemContrato,
        BtnAtualizarValoresEmLoteItemContrato,
        BtnEmitirRelatorio,
        RemanejarValor,
        BtnEmitirRelatorioRequisicoes
    },

    props: {
        contrato: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            itemContrato: null,
            itensSelecionados: [],
            erros: [],
            campos: [
                {
                    key: 'itemSelecao',
                    label: '',
                    customHead: true
                },
                {
                    key: 'exportarConsumo',
                    label: 'Exportar',
                },
                {
                    key: 'ordem',
                    label: 'Nº',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descTipoProduto',
                    label: 'Tipo Produto',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descTipoFaturamento',
                    label: 'Tipo Faturamento',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descNatureza',
                    label: 'Natureza',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valorUnitario',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Qtd',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'saldoValor',
                    label: 'Saldo Previsto',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'saldoValorReal',
                    label: 'Saldo Real',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'qtdSubItens',
                    label: 'Qtd SubItens',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'seqRM',
                    label: 'Seq RM',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'status',
                    label: 'Status',
                    sortable: true,
                    tdClass: 'text-center'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },
    methods: {
        detalharSubItens(itemContratoId) {
            this.itemContrato = this.contrato.itensContrato.filter((item) => {
                return item.itemContratoId === itemContratoId
            })[0]
        },

        situacoesVigenteDistribuido() {
            return (
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_VIGENTE2 ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.CONTRATO_DISTRIBUIDO ||
                this.contrato.idSituacaoContrato ===
                    situacaoContrato.ADITIVO_DISTRIBUIDO
            )
        },

        apostilamento() {
            return (
                this.$temAcessoView('CONT-APOST-05') &&
                this.situacoesVigenteDistribuido()
            )
        },

        contratoElaboracao() {
            return (
                this.$temAcessoView('CONT-ELAB-01') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.CONTRATO_DISTRIBUIDO_AGUARDANDO_INTEGRACAO
            )
        },

        verificaTipoAditivoPrazo() {
            return this.contrato.aditivoContrato != null
                ? this.contrato.aditivoContrato.aditivoTiposAditivo.every(
                      (x) => x.idTipoAditivo == 2
                  )
                : false
        },

        aditivoContratoIniciado() {
            return (
                this.$temAcessoView('CONT-ADITIV-00') &&
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO &&
                !this.verificaTipoAditivoPrazo()
            )
        },

        atualizacaoContrato() {
            return (
                this.$temAcessoView('CONT-ATUALIZAR-00') &&
                this.situacoesVigenteDistribuido() &&
                this.contrato.contratoVigente
            )
        },

        mostrarBtnAtualizarItemContrato(data) {
            if (
                ((this.apostilamento() || this.atualizacaoContrato()) &&
                data.status === 1 &&
                this.controleHistoricoAditivos()) && (this.$temAcessoView('CONT-UABS'))
            ) {
                return true
            } else if (((this.contratoElaboracao() || this.aditivoContratoIniciado()) &&  data.status === 1) && (this.$temAcessoView('CONT-UABS'))) {
                return true
            }
        },

        marcarDesmarcarTodas() {
            if (this.itensSelecionados.length > 0) {
                this.itensSelecionados = []
            } else {
                this.itensSelecionados = this.contrato.itensContrato
                    .filter((item) => {
                        return item.status === 1
                    })
                    .map((item) => {
                        return item.itemContratoId
                    })
            }
        },

        controleHistoricoAditivos() {
            return (
                this.contrato.contratoVigente ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.INICIADO_ADITIVO_CONTRATO ||
                this.contrato.idSituacaoContrato ==
                    situacaoContrato.ADITIVO_ASSINADO_AGUARDANDO_INTEGRACAO
            )
        },

        isEmpty(obj) {
            for (const prop in obj) {
                if (Object.hasOwn(obj, prop)) {
                    return false;
                }
            }
            return true;
        }
    },

    created() {},

    computed: {
        mostrarSubItens() {
            return this.itemContrato !== null
        },

        mostrarBtnInserirItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            ) 
        },

        mostrarBtnAtivarDesativarItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnAtualizarValoresEmLoteItemContrato() {
            return (
                (this.apostilamento() ||
                    this.contratoElaboracao() ||
                    this.aditivoContratoIniciado() ||
                    this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            )
        },

        mostrarBtnRemanejarValor() {
            if ( !(this.isEmpty(this.contrato)) 
                && (this.contrato.itensContrato.filter(p => p.status === 1).length < 2
                    || this.contrato.itensContrato.filter(p => p.saldoValor > 0).length == 0)
            ) {
                return false    
            }

            if (
                (this.apostilamento() || this.atualizacaoContrato()) &&
                this.controleHistoricoAditivos()
            ) {
                return true
            } else if (
                (this.contratoElaboracao() || this.aditivoContratoIniciado())
            ) {
                return true
            }
        },
    },

    watch: {
        contrato() {
            if (
                !this.apostilamento() &&
                !this.contratoElaboracao() &&
                !this.aditivoContratoIniciado() &&
                !this.atualizacaoContrato() &&
                !this.controleHistoricoAditivos()
            ) {
                this.campos.shift()
            }
        }
    }
}
</script>
